import { ContentMetadata } from '@candu-ai/content/types';
import { CRAFT_ROOT_ID } from 'craft/constants';
import { documentNodeAdapters } from 'craft/containers/Craft/format/documentNodeAdapters';
import { ContentDocument, CraftNodes } from 'craft/types';

import { documentNodeToCraftNode } from './documentNodeToCraftNode';

/**
 *
 * Read a Document to the Craft model
 *
 */
const documentNodesToCraftNodes = (
  { rootNodeId, nodes, stateProviders, placements }: ContentDocument,
  contentMetadata?: ContentMetadata,
): CraftNodes => {
  const craftId = (id: string) => (id === rootNodeId ? CRAFT_ROOT_ID : id);
  let craftNodes: CraftNodes = {};
  Object.entries(nodes).forEach(([nodeId, contentNode]) => {
    const newId: keyof typeof craftNodes = craftId(nodeId);
    // TODO this is important, why do we omit parent and hidden here ?
    const newNodes = documentNodeToCraftNode(
      newId,
      documentNodeAdapters(contentNode, nodeId, contentMetadata),
      stateProviders,
      placements,
    );

    // @ts-ignore
    craftNodes = {
      ...craftNodes,
      ...newNodes,
    };
  });
  return craftNodes;
};

// this is confusing for TS, why do we produce craftNodes without parent and add it later
// this causes a lot of confusion to safely type check

// craft requires a `parent` node.id for every node
const addParent = (craftNodes: CraftNodes, currentNodeId: string, parent: string): CraftNodes => {
  let currentNode = craftNodes[currentNodeId];
  // we should not add a `parent` for the root node
  if (currentNodeId !== CRAFT_ROOT_ID) {
    currentNode = { ...currentNode, parent };
  }
  const newNodes = [
    { [currentNodeId]: currentNode },
    ...(currentNode.nodes?.map((id) => addParent(craftNodes, id, currentNodeId)) ?? []),
  ];
  return newNodes.reduce((left, right) => ({ ...left, ...right }), {});
};

export const documentToCraft = (
  document: ContentDocument,
  contentMetadata?: ContentMetadata,
): CraftNodes => {
  const craftNodes = documentNodesToCraftNodes(document, contentMetadata);
  return addParent(craftNodes, CRAFT_ROOT_ID, CRAFT_ROOT_ID);
};
